import { createReducer, on } from '@ngrx/store';
import { DashboardData } from '../models/dashboard.models';
import * as DashboardActions from './dashboard.actions';

/**
 * Dashboard State Interface
 */
export interface DashboardState extends DashboardData {
  loading: boolean;
  error: string | null;
  lastUpdated: Date | null;
}

/**
 * Initial State
 */
export const initialState: DashboardState = {
  usage: null,
  subscription: null,
  recentDocuments: [],
  documentsTotal: 0,
  apiKeysCount: 0,
  loading: false,
  error: null,
  lastUpdated: null
};

/**
 * Dashboard Reducer
 */
export const dashboardReducer = createReducer(
  initialState,

  // Load Dashboard
  on(DashboardActions.loadDashboard, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(DashboardActions.loadDashboardSuccess, (state, { data }) => ({
    ...state,
    ...data,
    loading: false,
    error: null,
    lastUpdated: new Date()
  })),

  on(DashboardActions.loadDashboardFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Refresh Dashboard
  on(DashboardActions.refreshDashboard, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  // Clear Dashboard
  on(DashboardActions.clearDashboard, () => initialState),

  // Update Last Refreshed
  on(DashboardActions.updateLastRefreshed, (state, { timestamp }) => ({
    ...state,
    lastUpdated: timestamp
  }))
);

